import { normalize, mapObjectToList } from '../utils';

const initialState = {
  loading: false,
  errors: {},
  data: {},
};

const markets = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'MARKET_LIST_REQUEST':
      return {
        ...state,
        loading: true,
        data: {},
      };
    case 'MARKET_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        data: Object.assign({}, state.data, normalize(payload)),
      };
    case 'MARKET_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default markets;

export const marketsList = state => mapObjectToList(state.data);



// WEBPACK FOOTER //
// ./client/app/reducers/markets.js